<template>
  <div class="map-toolbar">
    <div class="tool-icons">
      <!-- 模拟图片中的一些图标，目前主要功能是全屏 -->
      <div class="tool-item" @click="$emit('toggle-fullscreen')" :title="isFullScreen ? '退出全屏' : '全屏'">
        <a-icon :type="isFullScreen ? 'fullscreen-exit' : 'fullscreen'" />
      </div>
      <!-- 占位图标，保持样式一致 -->
      <!-- 连线按钮 -->
      <div class="tool-item" :class="{ 'is-active': isLineAdding }" @click="$emit('add-line')" title="新增管线">
        <a-icon type="branches" />
      </div>
      <div class="tool-item" :class="{ 'is-active': isAdding }" @click="$emit('add-point')" title="新增物探点">
        <a-icon type="plus-circle" />
      </div>
      <!-- 测距按钮 -->
      <div class="tool-item" :class="{ 'is-active': isMeasuring }" @click="$emit('toggle-measure')" title="测距">
        <a-icon type="environment" />
      </div>
      <!-- 测面按钮 -->
      <div class="tool-item" :class="{ 'is-active': isMeasuringSurface }" @click="$emit('toggle-measure-surface')"
        title="测面">
        <a-icon type="border" />
      </div>
      <!-- 控制图层面板显示隐藏 -->
      <div class="tool-item" @click="$emit('toggle-layers')" :class="{ 'is-active': showLayers }" title="图层控制">
        <a-icon type="menu" />
      </div>
    </div>
    <div class="divider"></div>
    <div class="layer-dropdown">
      <a-select :value="value" placeholder="选择底图" style="width: 130px" size="small"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="handleChange">
        <a-select-option v-for="(config, key) in mapLayerConfigs" :key="key" :value="key">
          {{ config.name }}
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseLayerControl',
  props: {
    value: {
      type: String,
      default: 'layer1'
    },
    mapLayerConfigs: {
      type: Object,
      required: true
    },
    isFullScreen: {
      type: Boolean,
      default: false
    },
    showLayers: {
      type: Boolean,
      default: true
    },
    isAdding: {
      type: Boolean,
      default: false
    },
    isLineAdding: {
      type: Boolean,
      default: false
    },
    isMeasuring: {
      type: Boolean,
      default: false
    },
    isMeasuringSurface: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleChange (val) {
      this.$emit('change', val);
    }
  }
}
</script>

<style lang="less" scoped>
.map-toolbar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1001;
  background: rgba(255, 255, 255, 0.9);
  padding: 6px 12px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  border: 1px solid #ddd;

  .tool-icons {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-right: 12px;

    .tool-item {
      font-size: 18px;
      color: #555;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 4px;
      transition: all 0.3s;

      &:hover:not(.disabled) {
        background: rgba(0, 0, 0, 0.05);
        color: #1890ff;
      }

      &.is-active {
        color: #1890ff;
        background: rgba(24, 144, 255, 0.1);
      }

      &.disabled {
        color: #ccc;
        cursor: not-allowed;
      }
    }
  }

  .divider {
    width: 1px;
    height: 20px;
    background: #eee;
    margin-right: 12px;
  }

  .layer-dropdown {
    /deep/ .ant-select-selection {
      background: transparent;
      border: 1px solid #d9d9d9;
      border-radius: 4px;

      &:hover {
        border-color: #40a9ff;
      }
    }
  }
}
</style>
